<script setup>
import router from '@/router';
import { useRoute } from 'vue-router';
import { useMutation } from '@tanstack/vue-query';
import setPassword from '@/pages/auth/inviteLink/setPassword.vue';
import AuthFormLayout from '@/components/auth/authFormLayout.vue';
import partnrUpLogo from '@/assets/logo/PartnrUP_Full.svg';
import GuestLayout from '@/layouts/GuestLayout.vue';
import { API } from '@/services/index';
import { INVITE_CODE_STATUS_MUTATION } from '@/services/auth/mutations/index.js';
import { useAuthStore } from '@/stores/auth.store.js';

const route = useRoute();
const token = route.query?.token ?? null;
const isLoading = ref(false);
const resetErrors = ref(null);
const redirectUrl = ref('/dashboard');
const inviteData = ref(null);

const inviteCodeStatusMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql', INVITE_CODE_STATUS_MUTATION, payload);
  },
  onSuccess: (data) => {
    if (data.data.data.inviteCodeStatus) {
      console.log('inviteCodeStatus', data.data.data.inviteCodeStatus);
      inviteData.value = data.data.data.inviteCodeStatus;

      if (!data.data.data.inviteCodeStatus.new_user && useAuthStore().isAuth())
      {
        console.log('redirect to ' + data.data.data.inviteCodeStatus.url);
        router.push(data.data.data.inviteCodeStatus.url);
      } else 
      if (!data.data.data.inviteCodeStatus.new_user && !useAuthStore().isAuth()) {
        console.log('redirect to login ' + data.data.data.inviteCodeStatus.url);
        router.push({path : '/login', query: { url : data.data.data.inviteCodeStatus.url, token: token }});
      } else {
        redirectUrl.value = data.data.data.inviteCodeStatus.url;
      }
      isLoading.value = false;
    }
    if (data.data.errors) {
      // Helpers.showError(data.data.error.message);
      console.log('here', data.data.errors);
      resetErrors.value = data.data.errors[0]?.message != 'validation' ? data.data.errors[0]?.message : data.data.errors[0]?.extensions?.validation?.inviteCodeStatus[0];
      isLoading.value = false;
    }
  },
  onError: (error) => {
    console.log('error', error);
    isLoading.value = false;
  }
});
// check the codes status
inviteCodeStatusMutation.mutateAsync({ token: token });

</script>

<template>
  <GuestLayout>
    <AuthFormLayout :inviteData="inviteData">
      <div class="tw-h-full tw-w-full tw-p-6">
        <img class="tw-mx-auto tw-w-[142px]" :src="partnrUpLogo" alt="PartnrUp" />
        <h3 class="tw-mb-3 tw-text-center tw-font-mono tw-text-lg tw-font-bold tw-text-primary-blue">
          Welcome to partnrUP
        </h3>
        <h4>Please provide us a few details to finish setting up your account</h4>
          <setPassword :token="token" :redirectUrl="redirectUrl" :errors="resetErrors" />
      </div>
    </AuthFormLayout>
  </GuestLayout>
</template>

<style scoped></style>
